import React, { useState, useEffect } from "react";
import "./PartialPayment.css";
import axiosInstance from "../../../Config/axiosInstance";
import DatePicker from "react-datepicker";
import { ro } from "date-fns/locale";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NumericFormat } from "react-number-format";
import {Dialog,DialogTitle,DialogContent,DialogActions,Button,} from "@mui/material";

// Înregistrează localizarea română pentru componenta DatePicker,astfel încât formatul și calendarul să folosească limba română.
registerLocale("ro", ro);

const AddPartialPayment = ({
  isOpen,
  onClose,
  onAddPayment,
  invoiceId,
  invoiceNumber,
  remainingPayment,
  invoiceCurrency,
}) => {
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState(null);
  const [error, setError] = useState("");
  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
  };

  /*
   La închiderea dialogului:
    - resetează suma
    - resetează data
    - șterge eventualele erori
   Astfel, formularul se redeschide curat de fiecare dată.
   */
  useEffect(() => {
    if (!isOpen) {
      setAmount("");
      setDate(null);
      setError("");
    }
  }, [isOpen]);

  /*
    Validează și trimite plata parțială către backend.
    - verifică dacă toate câmpurile obligatorii sunt completate
    - verifică să nu se depășească suma rămasă de plată
    - trimite datele către API
    - la succes actualizează lista de plăți și închide dialogul
   */
  const handleSubmit = async () => {
    const isoDate = date ? date.toISOString().split("T")[0] : "";

    if (amount === "" || !isoDate) {
      setError("All fields are required.");
      return;
    }

    const numericAmount = parseFloat(amount);

    if (numericAmount > remainingPayment) {
      setError(
        `Amount exceeds the remaining payment (${remainingPayment} ${invoiceCurrency || ""}).`
      );
      return;
    }

    const newPayment = {
      invoice: invoiceId || null,
      amount,
      date: isoDate,
    };

    try {
      const response = await axiosInstance.post("/payments-commercial/", newPayment);
      onAddPayment(response.data);
      setAmount("");
      setDate(null);
      setError("");
      onClose();
    } catch (error) {
      console.error("Error adding payment:", error.response?.data || error.message);
      setError("Error adding payment.");
    }
  };

  return (
<Dialog
  open={isOpen}
  onClose={onClose}
  fullWidth
  maxWidth="sm"
  className="partialpayment-dialog"
>
  {/* Header-ul dialogului */}
  <DialogTitle>Add Payment</DialogTitle>

  <DialogContent dividers>
        <form
          className="payment-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          {/* Câmp readonly pentru numărul facturii */}
          <div className="payment-inputGroup">
            <label className="payment-label">Invoice Number</label>
            <input
              className="payment-input"
              type="text"
              value={invoiceNumber || ""}
              readOnly
            />
          </div>

          {/* Câmp pentru suma plății parțiale */}
          <div className="payment-inputGroup">
            <label className="payment-label">
              Amount {invoiceCurrency ? `(${invoiceCurrency})` : ""}
              <span className="payment-required-star">*</span>
            </label>

            <NumericFormat
              className="payment-input"
              value={amount}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              allowNegative={false}
              allowLeadingZeros={false}
              inputMode="decimal"
              placeholder="0,00"
              onValueChange={({ floatValue }) => {
                setAmount(floatValue ?? "");
              }}
            />
          </div>

          {/* Câmp pentru data plății */}
          <div className="payment-inputGroup">
            <label className="payment-label">
              Date<span className="payment-required-star">*</span>
            </label>

            <div className="datepicker-container invoicesregister-datepicker">
              <DatePicker
                selected={date}
                onChange={handleDateChange}
                dateFormat="dd.MM.yyyy"
                locale="ro"
                placeholderText="dd.mm.yyyy"
                className="datepicker-input"
                wrapperClassName="datepicker-wrapper"
              />
              <span className="calendar-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </span>
            </div>
          </div>

          {/* Mesaj de eroare afișat dacă validarea sau request-ul eșuează */}
          {error && <p className="payment-error">{error}</p>}
        </form>
      </DialogContent>

      <DialogActions sx={{ padding: "16px 24px" }}>
        {/* Buton de închidere dialog */}
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>

        {/* Buton pentru salvarea plății */}
        <Button onClick={handleSubmit} variant="contained">
          Add Payment
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPartialPayment;